ProductReviews = window.ProductReviews ?= {}
ProductReviews.Views ?= {}

ProductReviews.Collection = require './collections/product_reviews'
ProductReviews.Views.Main = require './views/product_reviews'
ProductReviews.Model = require './models/product_review'

ProductReviews.init = ({csrf, rootUrl, productReviews}, done) ->
  return done() unless productReviews.dealUuid

  {reviewable, dealUuid, dealUrl, dealTitle, pageSize, reviewCount, minimumReviewLength, maximumReviewLength, displayOptions} = productReviews
  ProductReviews.timeout = 3000

  collection = new ProductReviews.Collection productReviews.reviews, {rootUrl, csrf, dealUuid, displayOptions, pageSize}
  helpfulCollection = new ProductReviews.Collection productReviews.helpful?.reviews, {rootUrl, csrf, dealUuid, displayOptions}
  model = new ProductReviews.Model productReviews.userReview, {rootUrl, csrf, dealUuid, displayOptions}

  $ =>
    main = new ProductReviews.Views.Main {reviewable, dealUrl, dealTitle, collection, helpfulCollection, model, reviewCount, minimumReviewLength, maximumReviewLength}

    collection.view = main
    helpfulCollection.view = main
    model.view = main

    $('.product-reviews-anchor').click (e) ->
      e.preventDefault()
      $('html,body').animate {scrollTop: $('#product-reviews').offset().top}, 'slow'

    done()


module.exports = ProductReviews
